export function menu() {
const nav = document.getElementById("js-nav");
const menuBtn = document.getElementById("js-menu_btn");

const menuShow = () => {
  menuBtn.addEventListener("click", () => {
    menuBtn.classList.toggle("is-active");
    nav.classList.toggle("is-active");
  });

  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      document.getElementById('js-nav').classList.remove('is-active');
    });
  });
};

menuShow();

}